type CardContent = { corner: string; center: string };

const CONTENT_MAP: Record<string, CardContent> = {
    block: { corner: "", center: "" },
    reverse: { corner: "", center: "" },
    plus: { corner: "", center: "" },
    color: { corner: "8", center: "8" },
    draw: { corner: "", center: "" },
};

export function getCardContent(type: string): CardContent {
    const lower = type.toLowerCase();

    if(lower === "back") {
        return { corner: "", center: "" };
    }

    // Strip color prefix (r, g, b, y, n)
    const symbol = lower.substring(1);

    if(CONTENT_MAP[symbol]) {
        return CONTENT_MAP[symbol];
    }

    // Number card (0-9)
    return { corner: symbol, center: symbol };
}
